// @ts-check

import { onDomReady } from '../utils/dom';

/**
 * Tastatur-Reihenfolge der Tabs (Tabs-Bundle, A11yTabs).
 *
 * Das Bundle folgt dem ARIA-Muster: nur der aktive Reiter steht auf tabindex 0 (Reiterwechsel per Pfeiltasten), und das
 * aktive Panel ist selbst fokussierbar. Auf dieser Site sollen alle Reiter direkt per Tab erreichbar sein, und das Panel
 * ist kein eigener Fokus-Halt (es enthält fokussierbare Inhalte). Pfeiltasten sowie Home/End funktionieren weiterhin.
 * Das Bundle setzt die Attribute bei jedem Wechsel neu, deshalb wird nach seinem Ereignis „a11y-tabs:after-change"
 * nachgezogen.
 */

/**
 * @param {Element} tabs
 */
function normalizeTabs(tabs) {
    for (const tab of tabs.querySelectorAll('[role="tab"]')) {
        tab.setAttribute('tabindex', '0');
    }

    for (const panel of tabs.querySelectorAll('[role="tabpanel"]')) {
        panel.removeAttribute('tabindex');
    }
}

onDomReady(() => {
    for (const tabs of document.querySelectorAll('.content-tabs')) {
        normalizeTabs(tabs);
        tabs.addEventListener('a11y-tabs:after-change', () => normalizeTabs(tabs));
    }
});
